import React from "react";
import { Cross } from "../../../icons";

const SetupHeader = props => {
  const { onClose, currentStep, totalStep } = props;

  return totalStep ? (
    <div className="events-page-setup-steps-header">
      <div className="events-page-setup-steps-header-title">
        Step {currentStep} of {totalStep?.length}
      </div>
      <div className="events-page-setup-steps-header-line">
        {totalStep.map((i, key) => (
          <div
            key={key}
            className={`events-page-setup-steps-header-line-col ${
              i <= currentStep ? " active " : ""
            }`}
          ></div>
        ))}
      </div>
      <div className="events-page-setup-steps-header-close" onClick={onClose}>
        <Cross />
      </div>
    </div>
  ) : null;
};

export default SetupHeader;
